import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getInfoListFooterStyles = (checkStylingCondition, isLargeScreen, enableCollapsibleView) => {
  return StyleSheet.create({
    mainContainer: {
      marginHorizontal: tokens.spacing.SPACING_16
    },
    footerWrapper: Object.assign(Object.assign({
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    }, !enableCollapsibleView && {
      paddingTop: tokens.spacing.SPACING_20
    }), {
      paddingBottom: tokens.spacing.SPACING_20,
      paddingRight: checkStylingCondition ? tokens.spacing.SPACING_0 : tokens.spacing.SPACING_20
    }),
    singleElementWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end'
    },
    toolTipStyle: {
      marginLeft: tokens.spacing.SPACING_2,
      marginRight: isLargeScreen ? tokens.spacing.SPACING_0 : tokens.spacing.SPACING_2
    },
    toolTipLeftStyle: {
      marginLeft: tokens.spacing.SPACING_4
    },
    rightTextContainer: {
      paddingRight: checkStylingCondition ? tokens.spacing.SPACING_8 : tokens.spacing.SPACING_0
    },
    rightInfoTagContainer: {
      paddingVertical: tokens.spacing.SPACING_4,
      marginRight: tokens.spacing.SPACING_28
    },
    infoTagContainer: {
      paddingVertical: tokens.spacing.SPACING_4
    }
  });
};